<template>
  <div class="modal_on_modal">
    <div class="on_modal__container">
      <h2 class="inner_title">不可能な組み合わせです</h2>
      <p class="msg_container">現在の組み合わせを反転した上で<br>生地を張り替えますか?</p>
      <button
        type="button"
        :key="msg"
        @click="handleReply(msg)"
        v-for="msg in ['Cancel', 'OK']"
      >{{ msg }}</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleReply (msg) {
      this.$emit(msg === 'OK' ? 'resolve' : 'reject')
    }
  }
}
</script>
<style scoped lang="scss">
.modal_on_modal {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: #222, $alpha: 0.8);
  &.active {
    display: block;
  }
  .on_modal__container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 10% 15%;
    height: 80%;
    background-color: white;
    .inner_title {
      flex: 1 0 auto;
      width: 100%;
      text-align: center;
    }
    .msg_container {
      flex: 1 0 auto;
      margin: 0 20%;
      width: 60%;
      text-align: center;
    }
    button {
      margin: 0 3%;
    }
  }
}
</style>